import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { CircularProgress } from "common/components/CircularProgress"
import { TFunction } from "i18next"
import { Button } from "primereact/button"

interface ProgressProps {
  conciliada?: boolean
  forzada?: boolean
  percent: number
  t: TFunction
}

export const Progress = ({
  conciliada,
  forzada,
  percent,
  t,
}: ProgressProps) => {
  if (forzada) {
    return (
      <Button
        className='tw-mx-auto tw-flex tw-size-6 tw-items-center tw-justify-center tw-self-center tw-rounded tw-border tw-border-text-hyperlinks tw-bg-transparent tw-p-0 tw-text-text-hyperlink hover:!tw-bg-transparent hover:!tw-text-text-hyperlink'
        tooltipOptions={{ position: "right" }}
        tooltip={`${t("nsAssets.filters.status.forzosas")}`}
      >
        F
      </Button>
    )
  }
  if (conciliada) {
    return (
      <FontAwesomeIcon
        icon={["fal", "check-circle"]}
        className='tw-mx-auto tw-block tw-size-7 tw-self-center tw-text-success'
      />
    )
  }
  return (
    <CircularProgress
      radius={13.5}
      percent={Math.abs(percent)}
      gradientId='orange'
      linearGradient={["#FF9505", "#FF9505"]}
      round={false}
      colorCircle='#e6e6e6'
      className='tw-mx-auto tw-self-center tw-rounded-full'
    />
  )
}
